module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [(_vm.code == undefined) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n          Planos\n          "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato\n          " + _vm._s(_vm.contractId) + " "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Adesão\n          de Veículo Adicional\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard margin-b20 ad",
    class: _vm.step == 1 ? ' past4 ' : ''
  }, [_c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(0), _vm._v(" "), _c('small', [_vm._v("Cadastro de veículos")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_vm._m(2), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(3)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', {
    staticClass: "upper"
  }, [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + ".\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle[_vm.step]))]), _vm._v(" "), (_vm.step == 0) ? _c('vehicles', {
    key: _vm.tagInHandVehiclesKey,
    attrs: {
      "vehicles": _vm.vehicles,
      "type": _vm.user.type,
      "allowVehicles": _vm.qtdAllowed,
      "planId": _vm.planId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('generic-summary', {
    ref: "GenericSummary",
    attrs: {
      "order": _vm.salesOrder,
      "showAddress": true,
      "addressInit": _vm.addressInit,
      "account": _vm.user,
      "disablePayment": true
    },
    on: {
      "tag-activation-state": _vm.onTagActivationState,
      "shipment-type-change": _vm.onShipmentTypeChange
    },
    model: {
      value: (_vm.cpm),
      callback: function($$v) {
        _vm.cpm = $$v
      },
      expression: "cpm"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.tagInHandActivated) ? _c('div', {
    staticClass: "tag-success-banner"
  }, [_c('div', {
    staticClass: "tag-success-message"
  }, [_c('svg', {
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 22 22",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 20.1666C16.0627 20.1666 20.1667 16.0626 20.1667 11C20.1667 5.93737 16.0627 1.83331 11 1.83331C5.93743 1.83331 1.83337 5.93737 1.83337 11C1.83337 16.0626 5.93743 20.1666 11 20.1666Z",
      "stroke": "#2E7D32",
      "stroke-width": "1.83333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.25 11L10.0833 12.8334L13.75 9.16669",
      "stroke": "#2E7D32",
      "stroke-width": "1.83333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tagActivationSuccessMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "tag-success-actions"
  }, [(!_vm.isReplaceTagFlow) ? _c('button', {
    staticClass: "btn-link-add-vehicle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addAnotherVehicle
    }
  }, [_vm._v("\n          Adicionar outro veículo\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-finish-tag-flow",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finalizeTagInHandFlow
    }
  }, [_vm._v("\n          Finalizar\n          "), _c('svg', {
    attrs: {
      "width": "6",
      "height": "10",
      "viewBox": "0 0 6 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.666748 8.66669L4.66675 4.66669L0.666748 0.666687",
      "stroke": "white",
      "stroke-width": "1.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeAddress),
      expression: "changeAddress"
    }]
  }, [_c('address-comp', {
    ref: "addressMailing",
    attrs: {
      "address": _vm.newAddress,
      "type": "MAILING"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "action-buttons-box"
  }, [_c('div', {
    staticClass: "adhesion-footer-nav",
    class: {
      'adhesion-footer-nav--final-mobile': _vm.isMobile && _vm.step === 1
    }
  }, [_c('div', {
    attrs: {
      "id": "btn-container-adhesion-back-cancel"
    }
  }, [(_vm.step != 0 && !(_vm.isMobile && _vm.step === 1)) ? _c('button', {
    attrs: {
      "id": "button-back-adhesion",
      "disabled": _vm.tagInHandActivated
    },
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip_nv_back)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 5.33398L5.3335 8.00065M5.3335 8.00065L8.00016 10.6673M5.3335 8.00065H10.6668M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#5D3B81",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip_nv_back"
    }
  }, [_c('rect', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]), _vm._v("\n              Voltar\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "id": "button-cancel-adhesion",
      "disabled": _vm.tagInHandActivated
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 4L4 12M4 4L12 12",
      "stroke": "#E21C12",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-container-adhesion-advance"
    }
  }, [(!_vm.changeAddress) ? [(_vm.step == 0 && !(_vm.isCaminhoParana && _vm.step == 0) && _vm.isMobile) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n                Avançar\n                "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.isMobile && _vm.shipmentType != 4) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion-mobile",
      "disabled": _vm.cpm.error,
      "title": _vm.cpm.error
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n                Finalizar pedido\n                "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 0 && !(_vm.isCaminhoParana && _vm.step == 0) && !_vm.isMobile) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n                Avançar\n                "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 1 && !_vm.isMobile && _vm.shipmentType != 4) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion",
      "disabled": _vm.cpm.error,
      "title": _vm.cpm.error
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n                Finalizar pedido\n                "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e()] : [_c('button', {
    staticClass: "btn btn-purple",
    on: {
      "click": function($event) {
        return _vm.saveAddress()
      }
    }
  }, [_vm._v("\n                Alterar endereço\n                "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })])]], 2)])])])], 1) : _vm._e(), _vm._v(" "), _c('success-page', {
    attrs: {
      "code": _vm.code,
      "boletoUrl": _vm.boletoUrl,
      "type": 'newVehicle',
      "novoCartao": _vm.novoCartao,
      "salesOrder": _vm.salesResponse,
      "usuario": _vm.usuario,
      "validado": _vm.validado
    }
  }), _vm._v(" "), _c('error-page', {
    attrs: {
      "code": _vm.code,
      "stepPayment": 1,
      "type": 'newVehicle',
      "salesOrder": _vm.salesResponse,
      "validacaoFraude": _vm.validacaoFraude,
      "cmpId": _vm.cmpId
    },
    on: {
      "goToStep": _vm.goToStep
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-vehicle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Cadastro de veículos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Resumo e confirmação")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-64a6d0a1!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/vehicle/new-vehicle.vue
// module id = 2152
// module chunks = 1